import { Fare, Porter } from '@silbo/core';
import { useQueryClient } from '@tanstack/react-query';
import { getFaresQuery } from '../../queries';
import { FareStatusType } from '../../types/fare-status';

const getNextStatus = (status: FareStatusType) => {
  switch (status) {
    case 'ASSIGNED':
      return 'STARTED';
    case 'STARTED':
      return 'PATIENT_CARE';
    case 'PATIENT_CARE':
      return 'DONE';
    default:
      return 'ASSIGNED';
  }
};

const useUpdateFareQueryData = (porter?: Porter) => {
  const queryClient = useQueryClient();

  return (params: { fareId: string; status: FareStatusType; date?: Date }) =>
    queryClient.setQueryData([getFaresQuery(porter).className, getFaresQuery(porter).toJSON()], (data: Fare[]) => {
      const fareIndex = data.findIndex((fare) => fare.id === params.fareId);
      const dataCopy = [...data];
      if (fareIndex !== -1) {
        dataCopy[fareIndex].status = getNextStatus(params.status);
      }
      return dataCopy;
    });
};

export { getNextStatus, useUpdateFareQueryData };
